import { render, staticRenderFns } from "./index.vue?vue&type=template&id=020e31bc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020e31bc')) {
      api.createRecord('020e31bc', component.options)
    } else {
      api.reload('020e31bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=020e31bc&", function () {
      api.rerender('020e31bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/viewKnowledge/index.vue"
export default component.exports